import { useCallback, useState } from 'react';

import { useLocation } from 'react-router';

type Result = Readonly<{
	dismissed: boolean;
	onDismiss: () => void;
}>;

/**
 * Tracks dismissal scoped to the page it happened on, so navigation clears it automatically (the
 * keyed pathname stops matching) without a reset effect.
 */
export function useDismissState(): Result {
	const { pathname } = useLocation();
	const [dismissedPathname, setDismissedPathname] = useState<string | null>(null);

	const onDismiss = useCallback(() => {
		setDismissedPathname(pathname);
	}, [pathname]);

	return { dismissed: dismissedPathname === pathname, onDismiss };
}
